import React from 'react';
import domToImage from 'dom-to-image';
import CodeMirrorEditor, {
  WindowControls,
} from './components/CodeMirrorEditor';
import GraphController from './components/GraphController';
import Footer from './components/Footer';
import 'wired-elements';
// import Card from '@material-ui/core/Card';
// import CardContent from '@material-ui/core/CardContent';
import { PARSER_MODE, getRandomByMode } from './config';
import './fonts/font.css';
import './global.css';

window.setSvg = () => {
  const svg = document.getElementById('dom-to-img').firstChild;
  svg.setAttribute('width', '100%');
  svg.setAttribute('height', '100%');
  svg.setAttribute('preserveAspectRatio', 'xMinYMin meet');
  // svg.width = '100%';
  // svg.height = '100%';
  // svg.preserveAspectRatio = 'xMinYMin meet';
};

export default class Home extends React.Component {
  state = {
    mode: PARSER_MODE[0].id,
    code: '',
    svg: '',
    errMsg: '',
  };
  async componentDidMount() {
    await this.onRandom();
    await this.onGenerate();
  }
  setToRender = (mode, code) => {
    const { convert } = PARSER_MODE.find(({ id }) => id === this.state.mode);
    // const res = await convert(this.state.code);
    convert(code)
      .then(svg => {
        this.setState({ svg, errMsg: '' });
      })
      .catch(err => {
        this.setState({ svg: '', errMsg: err.message });
        console.error(err);
      });
  };
  onChangeMode = value => {
    console.log('onchangemode', value);
    this.setState({ mode: value });
  };
  onRandom = async () => {
    // debugger
    const code = await getRandomByMode(this.state.mode);
    this.setState({ code });
  };
  onChangeEditor = code => {
    this.setState({ code });
  };
  onGenerate = async () => {
    this.setToRender(this.state.mode, this.state.code);
  };
  downloadSvg = async () => {
    const dataUrl = await domToImage.toPng(
      document.getElementById('dom-to-img')
    );
    const downloadLink = document.createElement('a');
    downloadLink.download = 'diagram.jpeg';
    downloadLink.href = dataUrl;
    downloadLink.click();
  };
  render() {
    return (
      <div className="body">
        <h1 className="title">OXYGEN</h1>
        <p>Help you easily generate hand-drawn style diagrams.</p>
        <div className="controls">
          <GraphController
            mode={this.state.mode}
            onRandom={this.onRandom}
            changeMode={this.onChangeMode}
            onGenerate={this.onGenerate}
            onDownload={this.downloadSvg}
          />
          {/* <wired-input placeholder="Enter name"></wired-input> */}
          {/* <wired-button>Submit</wired-button> */}
          {/* <wired-card>ads</wired-card> */}
        </div>
        <div className="editor">
          <WindowControls />
          <CodeMirrorEditor
            value={this.state.code}
            onChange={this.onChangeEditor}
          />
        </div>
        <div className="show-card">
          <WindowControls />
          {this.state.svg ? (
            <div
              id="dom-to-img"
              className="preview"
              dangerouslySetInnerHTML={{ __html: this.state.svg }}
            />
          ) : (
            <div style={{ height: 400 }} />
          )}
        </div>
        <Footer />
      </div>
    );
  }
}
